/** Rows from a saved list-message preset (DB `rows` JSON). */
export function presetRowsFromPreset(preset) {
  if (!preset?.rows) return [];
  try {
    const parsed =
      typeof preset.rows === 'string' ? JSON.parse(preset.rows) : preset.rows;
    if (!Array.isArray(parsed)) return [];

    return parsed
      .map((row) => ({
        id: String(row?.id ?? row?.label ?? row?.title ?? '').trim(),
        label: String(row?.label ?? row?.title ?? row?.id ?? '').trim(),
      }))
      .filter((row) => row.label || row.id);
  } catch {
    return [];
  }
}

/** Keep target_node_id when preset rows change. */
export function mergeListPresetRows(fromPreset, existing = []) {
  return fromPreset.map((row) => {
    const prev = existing.find(
      (e) =>
        (row.id && e.id === row.id) ||
        (row.label && e.label === row.label) ||
        (row.id && e.label === row.id)
    );

    return {
      id: row.id,
      label: row.label,
      target_node_id: prev?.target_node_id ?? '',
    };
  });
}

export function listRowsConfigToList(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => ({
      id: String(row?.id ?? '').trim(),
      label: String(row?.label ?? '').trim(),
      target_node_id: row?.target_node_id || '',
    }))
    .filter((row) => row.label || row.id || row.target_node_id);
}
